export { default as hashSum } from "hash-sum";
